import { RadioButton } from "@progress/kendo-react-inputs";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { LoadingIndicator } from "../../../core/loading-indicator.component";
import { getDataWithToken, getEndPoint, getHtmlWithToken } from "../../../Utils/network.client";
import { API_END_POINT } from "../../../constants";
import { PrepareIndentTotalAbstract } from "./prepareindentnew-totalabstract";
import { PrepareIndentRouteDetailHeader } from "./prepareindentnew-routedetailheader";
import { PrepareIndentRouteWiseHeader } from "./prepareindentnew-routewiseheader";
import { PrepareIndentRouteWiseData } from "./prepareindentnew-routewisedata";
import { Button } from "react-bootstrap";
import { PrepareIndentRouteWiseAgent } from "./prepareindentnew-routewiseagent";
import DatePicker from "react-datepicker";
import { formatDate } from "@progress/kendo-intl";
import { SelectField } from "../../../core/select-field.component";
import { useGetSessions } from "../../../apiclient/master/useGetSessionApi";
import { Form, Formik } from "formik";
const html2pdf = require("html2pdf.js");

interface RouteAbstract {
  [key: string]: any; // Adjust based on actual API response
}

interface DispatchedStatus {
  [key: string]: boolean; // Define the expected structure
}

interface RouteAbs {
  routeabstract: RouteAbstract[];
  routeabstractheader: any[];
  routedetails: any[];
}

interface ParsedData {
  routeabs: RouteAbs[];
  totalabs?: any; // Add other properties as needed
}

const PrepareIndentNewReport = () => {

  const [selectedDate, setSelectedDate] = useState<string>("today");
  const [shift, setShift] = useState<number>(1);
  const [noRecord, setNoRecord] = useState<boolean>(false);
  const [parsedData, setParsedData] = useState<ParsedData | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [dispatchedStatus, setDispatchedStatus] = useState<DispatchedStatus>({});
  const [routewisedata, setRoutewiseIndentData] = useState<ParsedData | null>(null);
  const [visibleRoutes, setVisibleRoutes] = useState<{ [key: string]: boolean }>({});
  const formattedDate =
    selectedDate === "today"
      ? dayjs().format("DD.MM.YYYY")
      : dayjs().add(1, "day").format("DD.MM.YYYY");
  const [fromDate, setFromDate] = useState<Date>(
    new Date(dayjs().add(0, "months").format("MM/DD/YYYY"))
  );
  const [sessionData, setSessionData] = useState<{ value: string; label: string }[]>([]);
  const { data: fetchedSession } = useGetSessions();
  const [sessionid, setSessionId] = useState();

  useEffect(() => {
    if (fetchedSession) {
      const mappedSession = fetchedSession
        .filter((session: any) => session.name.trim().toLowerCase() !== "both")
        .map((session: any) => ({
          value: session.sessionId,
          label: session.name,
        }));
      setSessionData(mappedSession);
    }
  }, [fetchedSession]);

  const getindent = async () => {
    try {

      if (!sessionid || sessionid === 0) {
        alert("Please select session.");
        return; 
      }

      setLoading(true);

      // const formattedDate1 =
      //   selectedDate === "today"
      //     ? dayjs().format("YYYY-MM-DD")  // Get today's date
      //     : dayjs().add(1, "day").format("YYYY-MM-DD");

      const response = await getDataWithToken<any>(
        `${getEndPoint(API_END_POINT.REPORT)}/api/TotalAbstract/GetTotalAbstractByDateShift/${dayjs(fromDate).format("YYYY-MM-DD")}/${sessionid}`
      );

      // const response = await getDataWithToken<any>(
      //   `${getEndPoint(API_END_POINT.REPORT)}/api/TotalAbstract/GetTotalAbstractByDateShift/2025-03-19/1`
      // );

      console.log(response.data);

      const parsedResponse = JSON.parse(response.data.result);;
      setParsedData(parsedResponse);



    } catch (error) {
      setNoRecord(true);
      console.error("Error fetching data:", error);
      throw error; // Re-throwing in case you need to handle it outside
    } finally {
      setLoading(false);
    }
  };

  const fetchHtmlAndConvertToPdf = async (routeId: string) => {
    try {

      // const formattedDate1 =
      //   selectedDate === "today"
      //     ? dayjs().format("YYYY-MM-DD")  // Get today's date
      //     : dayjs().add(1, "day").format("YYYY-MM-DD");

      const response1 = await getDataWithToken<any>(
        `${getEndPoint(API_END_POINT.REPORT)}/api/PrepareIndent/SaveGatePass/${dayjs(fromDate).format("YYYY-MM-DD")}/${sessionid}/${routeId}`
      );

      // const response1 = await getDataWithToken<any>(
      //   `${getEndPoint(API_END_POINT.REPORT)}/api/PrepareIndent/SaveGatePass/2025-03-19/1/${routeId}`
      // );

      // const response1 = await axios.get(apiUrl1);

      console.log(response1.data);

      if (response1.data === 1) {

        const apiUrl = `${getEndPoint(API_END_POINT.REPORT)}/api/OldIndent/GenerateIndentPdf/${dayjs(fromDate).format("YYYY-MM-DD")}/${sessionid}/${routeId}`;

        // const apiUrl = `${getEndPoint(API_END_POINT.REPORT)}/api/OldIndent/GenerateIndentPdf/2025-03-19/1/${routeId}`;

        const htmlContent = await getHtmlWithToken(apiUrl);

        // Convert HTML string to a temporary div element
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = htmlContent;
        document.body.appendChild(tempDiv);

        // Convert HTML to PDF using html2pdf
        html2pdf()
          .from(tempDiv)
          .set({
            margin: 10,
            filename: "GatePass_DeliveryNote.pdf",
            image: { type: "jpeg", quality: 1 },
            html2canvas: { backgroundColor: null, scale: 1, useCORS: true },
            jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
          })
          .save()
          .then(() => {
            // Clean up after PDF is saved
            document.body.removeChild(tempDiv);
          });

        setDispatchedStatus((prevStatus) => ({
          ...prevStatus,
          [routeId]: true,
        }));

      }
    } catch (error) {
      console.error("Error fetching HTML and converting to PDF:", error);
    }
  };

  const getroutewiseindent = async (routeId: string) => {
    try {

      const formattedDate1 =
        selectedDate === "today"
          ? dayjs().format("YYYY-MM-DD")  // Get today's date
          : dayjs().add(1, "day").format("YYYY-MM-DD");

      const response = await getDataWithToken<any>(
        `${getEndPoint(API_END_POINT.REPORT)}/api/TotalAbstract/GetTotalAbstractByDateShiftRoute/${dayjs(fromDate).format("YYYY-MM-DD")}/${sessionid}/${routeId}`
      );

      // const response = await getDataWithToken<any>(
      //   `${getEndPoint(API_END_POINT.REPORT)}/api/TotalAbstract/GetTotalAbstractByDateShiftRoute/2025-03-19/1/${routeId}`
      // );

      console.log(response.data);

      const parsedResponse = JSON.parse(response.data.result);;
      setRoutewiseIndentData(parsedResponse);



    } catch (error) {
      console.error("Error fetching data:", error);
      throw error; // Re-throwing in case you need to handle it outside
    }
  };

  const toggleRouteDetails = (routeId: string) => {
    setVisibleRoutes(prevState => ({
      ...prevState,
      [routeId]: !prevState[routeId],
    }));

    if (!visibleRoutes[routeId]) {
      getroutewiseindent(routeId);
    }
  };

  // Initial values for Formik
  const initialValues = {
    sessionId: "", // default empty value for zone
    fromDate: fromDate,

  };

  useEffect(() => {
    if (routewisedata) {
      console.log("Updated routewiseagent:", routewisedata);
    }
  }, [routewisedata]);

  const handleSessionChange = (value: any) => {
    setSessionId(value);
    console.log("Sessionid id is:", sessionid);
  };

  return (

    <Formik
      initialValues={initialValues}
      onSubmit={(values) => {
        console.log("Form submitted with values: ", values);
      }}
    >
      {({ setFieldValue, values }) => (

        <Form>

          <div className="d-flex justify-content-between pt-1 pb-1 row col-10" style={{ marginLeft: "50px" }}>
            <div className="row px-4 mb-3 pt-2">
              <div className="col-md-4 mb-2">
                <h6>Date</h6>
                <DatePicker
                  className="form-control calendarBg"
                  selected={fromDate}
                  onChange={(date: Date) => setFromDate(date)}
                  dateFormat="dd/MM/yyyy"
                  placeholderText="To"
                />
              </div>

              <div className="col-md-4 mb-2">
                <h6>Select Session</h6>
                <SelectField
                  name="sessionId"
                  options={sessionData}
                  unSelectValue={0}
                  notifyChange={handleSessionChange}
                />
              </div>

              <div className="col-md-3 mb-2 d-flex align-items-start pt-3">
                <label>&nbsp;</label> {/* Empty label for alignment */}
                <button
                  className="btn btn-primary search-btn w-100 mt-1"
                  onClick={() => getindent()}
                  type="submit"
                >
                  <svg width="17" height="17" viewBox="0 0 17.5 17.5">
                    <path
                      id="Path_magnify"
                      data-name="Path / magnify"
                      d="M9.5,3a6.5,6.5,0,0,1,4.94,10.73l.27.27h.79l5,5L19,20.5l-5-5v-.79l-.27-.27A6.5,6.5,0,1,1,9.5,3m0,2A4.5,4.5,0,1,0,14,9.5,4.481,4.481,0,0,0,9.5,5Z"
                      transform="translate(-3 -3)"
                      fill="#fff"
                    />
                  </svg>
                  &nbsp;
                </button>
              </div>
            </div>
            <center>
              {loading && (
                <LoadingIndicator isLoading={true} showLabel={true} title="Loading.." />
              )}
            </center>
          </div>

          {/* <div className="d-flex justify-content-between pt-1 pb-1 row col-10" > */}
            {noRecord ? (
              <div className="row card border-0 sw-shadow radius-10  ms-5  me-5 col-12">
                <div><center><h4>No detail found for selected date. {dayjs(fromDate).format("DD.MM.YYYY")} </h4></center></div>
              </div>) : (
              <>
                {/* <div className="row card border-0 sw-shadow radius-10  ms-5  me-5 col-12"> */}
                  <div className="mt-5">
                    <div className="d-flex col-12">
                      <div className="col-6">
                        <h4>Total Abstract</h4>
                      </div>
                      <div className="col-6">
                        <h4 style={{ float: "right" }}>
                          Date: {dayjs(fromDate).format("DD.MM.YYYY")}
                        </h4>
                      </div>
                    </div>
                    {parsedData?.totalabs?.totalabstract != null && (
                      <PrepareIndentTotalAbstract totalabstract={parsedData.totalabs} />
                    )}
                  </div>
                {/* </div> */}

                {/* <div className="row card border-0 sw-shadow radius-10  ms-5 me-5 col-12"> */}
                  {parsedData != null && parsedData?.routeabs != null ? (
                    <div className="m-2">
                      <h4>Route Abstract</h4>
                    </div>
                  ) : (
                    <div></div>
                  )}

                  <div className="row col-12">
                    {parsedData?.routeabs
                      ?.filter(route =>
                        route?.routedetails?.length > 0 &&
                        route?.routeabstract?.length > 0
                      )
                      .map((route: RouteAbs, routeIndex: number) => {
                        return (
                          <div key={routeIndex} style={{ margin: "5px" }}>
                            {/* Route Header */}
                            {route.routedetails.length > 0 && (
                              <PrepareIndentRouteDetailHeader routeDetailHeader={route.routedetails[0]} SelectedDate={dayjs(fromDate).format("DD.MM.YYYY")} />
                            )}

                            {/* Route Abstract Table */}
                            {route?.routeabstract?.length > 0 && (
                              <table
                                className="striped bordered hover"
                                style={{ width: "100%" }}
                                border={1}
                                cellPadding={5}
                                cellSpacing={5}
                              >
                                <thead>
                                  {route?.routeabstractheader && route.routeabstractheader.length > 0 && (
                                    <PrepareIndentRouteWiseHeader routeAbstractHeader={route.routeabstractheader[0]} />
                                  )}
                                </thead>
                                <tbody>
                                  {route?.routeabstract?.map((item, itemIndex) => (
                                    <PrepareIndentRouteWiseData key={itemIndex} routeAbstractRow={item} />
                                  ))}
                                </tbody>
                              </table>
                            )}

                            {/* Button */}
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                              <div style={{ marginTop: "10px" }}>
                                <Button
                                  className="btn-primary btn search-btn"
                                  style={{ marginRight: "10px" }}
                                  onClick={() => fetchHtmlAndConvertToPdf(route.routedetails[0].rid)}
                                >
                                  {route.routedetails[0].isdespatched || dispatchedStatus[route.routedetails[0].rid]
                                    ? "Download"
                                    : "Close & Prepare"}
                                </Button>
                                <Button
                                  className="btn-primary btn search-btn"
                                  onClick={() => toggleRouteDetails(route.routedetails[0].rid)}
                                >
                                  {visibleRoutes[route.routedetails[0].rid] ? "Hide" : "Show Detail"}
                                </Button>
                              </div>

                              {visibleRoutes[route.routedetails[0].rid] && (
                                <div
                                  style={{
                                    width: "100%",
                                    overflowX: "auto",
                                    padding: "10px",
                                    marginTop: "10px", // Ensures it doesn't affect the button alignment
                                  }}
                                >
                                  <PrepareIndentRouteWiseAgent  key={`agent-${route.routedetails[0].rid}`} date={fromDate} shift={sessionid} route={route.routedetails[0].rid} />
                                </div>
                              )}
                            </div>

                            <br />
                          </div>
                        );
                      })}
                  </div>

                {/* </div> */}

              </>)}
          {/* </div> */}
        </Form>
      )}
    </Formik>
  );
};

export default PrepareIndentNewReport;
